import React from 'react';
import { InputText } from 'primereact/inputtext';
import iconError from '../../assests/images/icon-err.png';

const CommonInput = ({ name, label, onClick, getValues = () => { }, placeholder, readOnly,
  onKeyDown, register, maxLength, errors, disabled, validationFn, requiredField, inputStyle,
  errorStyle, resErrorFlag, errorPassword, icon }) => {
  const fieldError = errors && errors.message;
  return (
    <div className="field">
    { label && <label htmlFor={name} className="mt-2 fw-bold">{label}  {requiredField ? <span className="required"> *</span> : ''}</label>}
    <div className="input-wrapper">
  
      <InputText  
        id={name}
        {...register(name, {
          validate: (value) => {
            // console.log("Input", value, name);
            
            const { errorFlag, error } = validationFn({ FieldName: name, value });
            if (errorFlag==true) {
              return error;
            }
            return true;
          }
        })}
        placeholder={placeholder}
        autoComplete="off"
        disabled={disabled}
        maxLength={maxLength && 2}
        onKeyDown={onKeyDown}
        onBeforeInput={(e) => {
          const { value, selectionStart, selectionEnd } = e.target;
          const isAllSelected = selectionStart === 0 && selectionEnd === value.length;

          if (e.data === " " && (value.length === 0 || isAllSelected)) {
            e.preventDefault();
          }
        }}
        readOnly={readOnly} 
        onClick={onClick}
      //  className={(errors?.[name]) || resErrorFlag  ? 'p-invalid p-inputtext error-placeholder' : inputStyle ?  'input-style-common mt-1 p-inputtext' : 'mt-1 p-inputtext'}
      className={`${disabled ? 'input-disabled' : ''} ${(errors?.[name]) || resErrorFlag ? 'p-invalid p-inputtext error-placeholder' : inputStyle ? 'input-style-common mt-1 p-inputtext' : 'mt-1 p-inputtext'}`}
     />
        {icon &&  <img className="input-icon" src={iconError} />}
      </div>
      {(errors?.[name])&& <small className="p-error">{errorStyle ==true && errors?.[name]?.message }</small>}
    </div>
  );
};

export default CommonInput;

